import React, { lazy, Suspense, useEffect } from "react";
import styles from './AppActions.module.scss'
import stylesCloudList from '../../components/CloudList.module.scss';
import Button from "../../components/ripple/Button";
import { addModalLayer, wipeModalState } from "../../redux/actions/ModalActions";
import Loading from "../../components/Loading";
import { generateSlug } from "../../helpers/common";
import { store } from '../../redux/store'
import { useRouter } from "next/router";
import { NAV_STACK_LIST } from "../../settings/navigation";
import { URL_CONSULT_DEPLOYMENT } from "../../settings/content/linksExternal";

const CloudList = lazy(() => import('../../components/CloudList'));

function AppActions({stackData, clouds}) {

    const router = useRouter();

    useEffect(() => {
        return () => {
            store.dispatch(wipeModalState());
        }
    }, []);

    return (
        <div
            className={styles.buttons}
        >
            <a
                className={styles.buttons__support}
                href={URL_CONSULT_DEPLOYMENT}
                target='_blank'
                draggable='false'
                tabIndex='-1'
            >
                <Button
                    displayType='text'
                    className={styles.buttons__support__button}
                    form='deployment-form'
                    iconLeft='fas fa-headset'
                    title='Deploy with the help of tech consultant'
                    visuals={{height: '5rem', borderRadius: '25px'}}
                />
            </a>
            <Button
                className={styles.buttons__deploy}
                iconRight={`fas fa-cloud`}
                title={`Deploy to cloud`}
                visuals={{height: '5rem', borderRadius: '25px'}}
                type={'button'}
                // onClick={nextOnClick}
                onClick={() => {
                    store.dispatch(addModalLayer({
                        component: (
                            <Suspense fallback={<Loading/>}>
                                <CloudList
                                    app={stackData}
                                    clouds={clouds}
                                    title={`Choose cloud to deploy ${stackData.name}`}
                                    onClick={cloudData => {
                                        router.push(`${NAV_STACK_LIST}/${generateSlug(stackData.name)}/${generateSlug(cloudData.name)}`);
                                    }}
                                />
                            </Suspense>
                        ),
                        classNameLayer: stylesCloudList.cloudListModal,
                    }))
                }}
            />
        </div>
    )
}

export default AppActions